<input #field
  [hidden]="showMaskedField"
  type="number"
  class="form-control"
  [class.required]="required"
  [ngModel]="numericInputValue"
  [value]="numericInputValue"
  (ngModelChange)="writeValue($event)"
  (blur)="onTouched()"
  min="-99999999.99"
  max="99999999.99"
  step="0.01"
  [attr.required]="required ? '' : null">

<input #fieldMasked
  [hidden]="!showMaskedField"
  type="text"
  class="form-control"
  [(ngModel)]="maskedValue"
  (focus)="maskedFocus($event)"
  (ngModelChange)="maskedChange($event)"
  [attr.required]="required ? '' : null">
